import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { TbExternalLink } from 'react-icons/tb'
import styled from '@emotion/styled'
import { Button } from 'antd'
import { STRIPE_CONNECT_OAUTH_ENDPOINT } from 'packages/@slerp/client'
import { QUERY_STRIPE_CONNECT_URL } from 'components/Settings/actions'
import { useQuery } from '@apollo/client'
import { useSession, isAdmin } from '@slerp/accounts'
import { useGlobalQuery } from 'hooks/useGlobalQuery'

const StripeAlert = () => {
  const { merchant, user } = useSession()
  const { cards, isLoading } = useGlobalQuery()

  const [isStripeOnboarded, setIsStripeOnboarded] = useState(true)
  const [isStripeConnected, setIsStripeConnected] = useState(true)

  const redirect_uri = STRIPE_CONNECT_OAUTH_ENDPOINT

  const { loading: loadingStripeConnectUrl } = useQuery(
    QUERY_STRIPE_CONNECT_URL,
    {
      variables: {
        redirectUri: redirect_uri,
        merchantId: merchant?.id
      },
      fetchPolicy: 'no-cache',
      skip: !isAdmin(user) || !merchant,
      onCompleted: (data) => {
        setIsStripeOnboarded(!!data.stripeConnectUrl.hasOnboarded)
        setIsStripeConnected(!!data.stripeConnectUrl.hasConnected)
      }
    }
  )

  const isTransacting = !!cards?.length && isStripeConnected

  if (
    (isTransacting && isStripeOnboarded) ||
    isLoading ||
    loadingStripeConnectUrl
  )
    return <></>

  const message = isTransacting
    ? `Your Slerp Pay account is connected, but currently unable to transact. Please visit your Stripe Dashboard to finish your onboarding`
    : `To complete your setup and start transacting, please enter your payment details`
  const buttonText = isTransacting
    ? 'Complete onboarding'
    : 'Enter payment details'

  return (
    <EnableStripe>
      <div>
        <span>{message}</span>
      </div>
      <Link to='/settings/accounts-and-billing'>
        <FlexButton>
          {buttonText}
          <TbExternalLink style={{ fill: '#4a4a68' }} size='16' />
        </FlexButton>
      </Link>
    </EnableStripe>
  )
}

const FlexButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
`

const EnableStripe = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 24px;

  background-color: #e9e8fc;
  border: 1px solid #4a4a68;
  border-radius: 6px;

  color: #4a4a68;
  font-weight: 500;
  font-size: 13px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`

export default StripeAlert
